import DOM from '@common/DOM/DOM'

/**
 * Egy modalhoz tartozó elem animálása.
 * @param elem      - A modalhoz tartozó elem, amit animálunk.
 * @param className - Az animációt tartalmazó class.
 */
export default function animateModalPart (elem: HTMLElement, className: string): Promise<void> {
  return new Promise((resolve) => {
    DOM.once(elem, 'animationend', () => {
      elem.classList.remove(className)
      resolve()
    })

    elem.classList.add(className)
  })
}
